import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-descargar-informe-venta',
  templateUrl: './descargar-informe-venta.component.html',
  styleUrls: ['./descargar-informe-venta.component.sass']
})
export class DescargarInformeVentaComponent implements OnInit {

  constructor() { }

  nombreExcel:any;
  rutaApi: string = environment.RUTA_API;

  ngOnInit(): void {
  }

}
